import * as React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { StoreState } from "../../reducers/root-reducer";

export interface ListSectionProps {
	title: string;
	actions?: JSX.Element;
	titleBackground?: string;
	overlay?: JSX.Element;
	onClick?: () => void;
	onTitleClick?: () => void;
}

interface ConnectedListSectionProps extends WithStyles<typeof styles> {}

type Props = ListSectionProps & ConnectedListSectionProps;

export class ListSection extends React.Component<Props, {}> {
	render() {
		const {
			classes,
			title,
			children,
			actions,
			titleBackground,
			overlay,
			onClick,
			onTitleClick
		} = this.props;

		return (
			<div className={classes.root} onClick={onClick}>
				<div
					className={classes.titleContainer}
					onClick={onTitleClick}
					style={{
						backgroundColor: titleBackground
							? titleBackground
							: "white"
					}}
				>
					<Typography className={classes.title}>{title}</Typography>
					{actions}
					{overlay}
				</div>
				<div className={classes.content}>
					<div className={classes.contentInner}>{children}</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state: StoreState) => ({});

const styles = (theme: Theme) =>
	createStyles({
		root: {
			marginBottom: 35
		},
		titleContainer: {
			padding: 20,
			background: "white",
			position: "sticky",
			top: 0,
			boxShadow: theme.shadows["1"],
			zIndex: 1,
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center",

			"@media (max-width: 959px)": {
				padding: 10
			}
		},
		title: {
			fontSize: "1.4rem",
			fontWeight: 400
		},
		content: {
			padding: 20,
			overflow: "hidden",

			"@media (max-width: 959px)": {
				padding: 10
			}
		},
		contentInner: {
			margin: -10,
			display: "flex",
			flexWrap: "wrap"
		}
	});

export const ConnectedListSection = withStyles(styles)(
	connect(mapStateToProps)(ListSection)
);
